import styled, { keyframes } from "styled-components";

const boxFade = keyframes`
  15% { transform: translateY(-52px) }
  20% { transform: translateY(-52px) }

  35% { transform: translateY(-104px) }
  40% { transform: translateY(-104px) }

  55% { transform: translateY(-156px) }
  60% { transform: translateY(-156px) }

  75% { transform: translateY(-208px) }
  80% { transform: translateY(-208px) }

  95% { transform: translateY(-260px) }
  100% { transform: translateY(-260px) }
`;

export const CommentContainer = styled.div`
  padding: 16px 16px 32px 16px;
  background-color: #004AFF;
`;

export const ContentWrap = styled.div`
  padding: 22px 16px 16px;
  border-radius: 16px;
  background-color: #FFFFFF;
`;

export const ApplyWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
`;

export const TitleWrap = styled.div`
  width: 70.426%;
  margin: 0 auto;
`;

export const Title = styled.div`
  margin: 0 auto;
  width: 100%; 
  padding-top: 45.428%; 
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
`;

export const ApplyInput = styled.textarea`
  height: 80px;
  width: 90.24%;
  border: 1px solid #EDEDED;
  border-radius: 2px;
  padding: 10px 16px;
  color: #222222;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  resize: none;

  &::placeholder {
    color: #979797;
  }

  &:focus {
    border-color: #222222;
  }
`;

export const ApplyBtnWrap = styled.button`
  width: 100%;
  margin: 8px auto 0;
  background: transparent;
  border: none;
  box-sizing: border-box;
`;

export const ApplyBtn = styled.div`
  width: 100%; 
  margin: 0 auto;
  padding-top: 21.62%; 
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  margin: 20px auto;
  background: #000000;
  opacity: 0.1;
`;

export const CommentListWrap = styled.div`
  padding: 16px;
  background-color: rgba(230, 237, 255, 0.5);
  border-radius: 8px;
`;

export const Content = styled.div`
  height: 260px;
  overflow: hidden;
`;

export const Comment = styled.div`
  height: 40px;
  box-sizing: border-box;
  animation: ${boxFade} 5s infinite;

  & + & {
    margin-top: 12px;
  }
`;

export const UserName = styled.p`
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  color: #656565;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const UserComment = styled.p`
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  color: #222222;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const EventDescription = styled.ul`
  margin-top: 16px;
  list-style: outside;
  padding-left: 18px;
`;

export const Text = styled.li`
  position: relative;
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  color: #656565;
`;

export const ShareWrap = styled.button`
  width: 100%;
  margin: 16px auto 0;
  background: transparent;
  border: none;
  box-sizing: border-box;
`;

export const ShareBtn = styled.div`
  width: 100%; 
  margin: 0 auto;
  padding-top: 19.512%; 
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
`;

export const ToolTipWrap = styled.div`
  width: 59.451%;
  margin: 4px auto 0;
`;

export const ToolTip = styled.div`
  width: 100%; 
  margin: 0 auto;
  padding-top: 17.333%; 
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
`;
